export default "__VITE_ASSET__DvsgvfI9__"